import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO,
} from '../../services/wealthlane-award-services';
import { SandboxService } from '../../services/wealthlane-identity-services';

const useGetSandboxById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO | undefined,
  unknown
> => {
  const sandboxById = useQuery(
    ['getSandboxById', id],
    async () => {
      if (id) {
        return await handleRequest(SandboxService.getApiIdentityApiSandbox1(id));
      }
    },
    {
      select(data) {
        return {
          ...data,
          sandboxType: data?.sandboxType === 'Empty' ? 1 : 2,
          visibility: data?.visibility === 'Public' ? 1 : 2,
        };
      },
    }
  );

  return sandboxById;
};

export default useGetSandboxById;
